<div
  *ngIf="aggregationCategories?.length > 0"
  class="o-grid--small">
  <div class="o-grid__item col-12">
    <span
      class="button-filter"
      [class.active]="enabledFilters.length > 0"
      (click)="filterOpen.emit()">
      <span>{{ localizationConstants.TOOL_FILTERS_TITLE | translate }}</span>
      <mat-icon
        *ngIf="enabledFilters.length === 0"
        svgIcon="filter-sliders"></mat-icon>
      <span
        *ngIf="enabledFilters.length > 0"
        class="chip-filter__count">
        {{ enabledFilters.length }}
      </span>
    </span>
  </div>

  <div class="o-grid__item col-12">
    <div class="filter-state__list">
      <mat-chip-listbox [selectable]="false">
        <mat-chip-option
          [disableRipple]="true"
          (removed)="onFilterItemRemove(item)"
          *ngFor="let item of enabledFilters">
          {{ item.categoryName | translate }}: {{ item.valueTitle | translate }}
          <button
            class="remove-chip__button"
            matChipRemove>
            <mat-icon
              class="icon-size-xs"
              svgIcon="close"></mat-icon>
          </button>
        </mat-chip-option>

        <mat-chip-option
          *ngIf="enabledFilters.length > 0"
          class="button-filter__clear"
          (click)="onClearAll()">
          {{ localizationConstants.TOOL_FILTERS_CLEAR_ALL | translate }}
        </mat-chip-option>
      </mat-chip-listbox>
    </div>
  </div>
</div>
